import { motion, useReducedMotion, type MotionProps } from "framer-motion";
import { createElement, type ElementType, type ReactNode } from "react";

interface RevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  as?: ElementType;
  /** Override the default viewport margin (CSS shorthand). */
  margin?: string;
}

/**
 * Scroll-triggered fade + rise. Honors prefers-reduced-motion (opacity-only).
 * Use to give marketing sections a consistent entrance rhythm.
 */
export function Reveal({
  children,
  className,
  delay = 0,
  as = "div",
  margin = "-80px",
}: RevealProps) {
  const reduce = useReducedMotion();
  const MotionTag = motion(as as ElementType) as React.ComponentType<MotionProps & { className?: string }>;
  return (
    <MotionTag
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin }}
      transition={{ duration: 0.4, ease: [0.2, 0.8, 0.2, 1], delay }}
    >
      {children}
    </MotionTag>
  );
}